var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatNoAvatarD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#EDE8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9148 10C29.1035 10 29.5346 10.1238 29.9691 10.3562C30.4037 10.5886 30.7447 10.9296 30.9772 11.3642C31.2096 11.7988 31.3333 12.2298 31.3333 13.4185V22.5815C31.3333 23.7702 31.2096 24.2012 30.9772 24.6358C30.7447 25.0704 30.4037 25.4114 29.9691 25.6438C29.5346 25.8762 29.1035 26 27.9148 26H21.9973L17.0405 30.9589C16.6501 31.3495 16.0169 31.3496 15.6263 30.9592C15.4387 30.7716 15.3333 30.5172 15.3333 30.2519V26H13.4185C12.2298 26 11.7988 25.8762 11.3642 25.6438C10.9296 25.4114 10.5886 25.0704 10.3562 24.6358C10.1238 24.2012 10 23.7702 10 22.5815V13.4185C10 12.2298 10.1238 11.7988 10.3562 11.3642C10.5886 10.9296 10.9296 10.5886 11.3642 10.3562C11.7988 10.1238 12.2298 10 13.4185 10H27.9148Z",
    fill: "url(#paint0_linear_1975_35)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1975_35",
    x1: 20.6667,
    y1: 10,
    x2: 20.6667,
    y2: 31.2519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatNoAvatarD);
export default __webpack_public_path__ + "static/media/chat_no_avatar_d.239365b914da00bebf1cba813fd73f0e.svg";
export { ForwardRef as ReactComponent };